module.exports = __webpack_public_path__ + "static/media/PingvinenGuld.766036ee.png";